import * as React from "react";
import { dropdownItems } from "./data/data";
import Payment from "../../Payment";
import { Link } from "react-router-dom";
import { CASE, useAuthContext } from "../../../context/useAuthContext";
import { IMAGE_SRC } from "../../../common/constants";
import { BiLogOut } from "react-icons/bi";
import { FiLogOut } from "react-icons/fi";
import { toast } from "react-toastify";

export interface IDropdownPop {
  showPayment: boolean;
}
export interface DropdownProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const Dropdown = ({ show, setShow }: DropdownProps) => {
  const { dispatch: dispatchAction, state } = useAuthContext();
  const currentUser = state.authUser;
  const isAuthenticated = state.isAuthenticated;
  const [showDropdownPop, setShowDropdownPop] = React.useState<IDropdownPop>({
    showPayment: false,
  });
  const handleChange = (index: number) => {
    setShowDropdownPop((prev) => ({
      ...prev,
      showPayment: index === 3 ? !prev.showPayment : false,
    }));
  };
  const handleLogout = async () => {};
  return (
    <div
      className={`absolute  dropdown-menu select-none overflow-hidden -left-[146px] w-44 z-50 rounded-md bg-menuBg flex  top-9 flex-col ${
        show ? "" : "hidden"
      }`}
    >
      {dropdownItems.map((item, index) => {
        return (
          <Link
            to={
              isAuthenticated && item.title === "Login/Signup" ? "/" : item.link
            }
            onClick={() => handleChange(index)}
            key={item.id}
            className="flex items-center gap-x-3 text-white py-[6px] px-3 hover:bg-primary transition-all cursor-pointer"
          >
            <div className="relative  text-white profile-icon">
              <img src={item.icon} alt="" />
            </div>

            <span className="text-sm text-inherit">
              {isAuthenticated && item.title === "Login/Signup"
                ? currentUser?.fullName
                : item.title}
            </span>
          </Link>
        );
      })}

      <Payment
        setShow={setShowDropdownPop}
        show={showDropdownPop.showPayment}
      />
      {isAuthenticated && (
        <div
          onClick={handleLogout}
          className="flex items-center gap-x-3 text-white py-[6px] px-3 hover:bg-primary transition-all cursor-pointer"
        >
          <div className="relative  text-white profile-icon">
            <FiLogOut className="text-base"></FiLogOut>
          </div>

          <span className="text-sm text-inherit">Logout</span>
        </div>
      )}
    </div>
  );
};

export default React.memo(Dropdown);
